// 03-11 (rebrand; Pau: «si paso un chat a contrato con Santi que se me agrupe en otro lugar»): lo que la lista y la
// oficina necesitan saber de los contratos con Santi de cada agente, calculado de la lista de contratos (la misma que
// pinta su tablero, viva por el socket `oficina:pelotas`). Puro + un hook que asegura que la lista está cargada.
import { useEffect, useMemo } from 'react';
import type { SantiDelAgente, SantiPorAgente } from '../marco/situacion';
import { usePelotasStore } from './store';
import { YO } from './tiempo';
import type { ContratoDTO } from './tipos';

/** Por agente: «con Santi» si TODOS sus contratos abiertos tienen la pelota en el lado de Santi; y si hay tarjeta esperando tu sí. */
export function santiPorAgente(contratos: readonly ContratoDTO[]): SantiPorAgente {
  const porAgente = new Map<string, ContratoDTO[]>();
  for (const c of contratos) {
    if (!c.agentId) continue;
    porAgente.set(c.agentId, [...(porAgente.get(c.agentId) ?? []), c]);
  }
  const fuera = new Map<string, SantiDelAgente>();
  for (const [agentId, suyos] of porAgente) {
    fuera.set(agentId, { conSanti: suyos.every((c) => c.lado !== YO), esperaTuSi: suyos.some((c) => c.esperaTuSi) });
  }
  return fuera;
}

/** El mapa vivo para la lista y la oficina (carga la lista de contratos si nadie la había pedido). */
export function useSantiPorAgente(): SantiPorAgente {
  const lista = usePelotasStore((s) => s.lista);
  const cargar = usePelotasStore((s) => s.cargarLista);
  useEffect(() => {
    if (!usePelotasStore.getState().lista) void cargar();
  }, [cargar]);
  return useMemo(() => (lista?.configurado ? santiPorAgente(lista.contratos) : new Map()), [lista]);
}
